// extracted by mini-css-extract-plugin
export default {"youHaveChosen":"l-JDV","matchingGiftInfo":"oojRZ","paymentMethodText":"mVdq5","commentContainer":"WHKut"};